import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useActiveSpecialistRole from './useActiveSpecialistRole';

const normalizeProcess = (process = '') => String(process || '').trim().toLowerCase();

/**
 * Permiso de carga masiva por módulo:
 * - flow ON: Gestor o Pre-Gestor cargan la matriz del caso; Alimentador carga términos (hoja term)
 * - flow OFF: legacy Feeder + módulo en moduleAccess
 */
const useBulkUploadAccess = (moduleProcess) => {
  const roleLogin = useSelector((state) => state.userRole.roleLogin);
  const { flowEngineEnabled, canBulkUpload, roleKey } = useActiveSpecialistRole();
  const processKey = normalizeProcess(moduleProcess);

  const moduleAccess = roleLogin?.moduleAccess || [];
  const isAdministrator = !!roleLogin?.isAdministrator;

  const hasModulePermission = useMemo(() => {
    if (!processKey) {
      return false;
    }
    if (isAdministrator) {
      return true;
    }
    return moduleAccess.map(normalizeProcess).includes(processKey);
  }, [isAdministrator, moduleAccess, processKey]);

  const canUpload = useMemo(() => {
    if (!hasModulePermission) {
      return false;
    }
    if (flowEngineEnabled) {
      return roleKey === 'feeder' || canBulkUpload;
    }
    return roleKey === 'feeder';
  }, [canBulkUpload, flowEngineEnabled, hasModulePermission, roleKey]);

  return {
    flowEngineEnabled,
    canBulkUpload,
    hasModulePermission,
    canUpload,
    moduleAccess,
    roleKey
  };
};

export default useBulkUploadAccess;
